// Родители из создателя персонажа GTA Online: id для геймода, имя и портрет.
// Портреты лежат в client_packages/interface/img/parents/<id>.png — это те же
// лица, что показывает оригинальный creator, поэтому выбор идёт «по фотографии»,
// а не по номеру.
const P = (id, name) => ({ id, name, photo: `img/parents/${id}.png` });

export const DADS = [
    P(0, 'Бенджамин'), P(1, 'Даниэль'), P(2, 'Джошуа'), P(3, 'Ной'), P(4, 'Эндрю'),
    P(5, 'Хуан'), P(6, 'Алекс'), P(7, 'Айзек'), P(8, 'Эван'), P(9, 'Итан'),
    P(10, 'Винсент'), P(11, 'Энджел'), P(12, 'Диего'), P(13, 'Адриан'), P(14, 'Габриэль'),
    P(15, 'Майкл'), P(16, 'Сантьяго'), P(17, 'Кевин'), P(18, 'Луис'), P(19, 'Сэмюэл'),
    P(20, 'Энтони'),
    // особые лица из оригинала
    P(42, 'Клод'), P(43, 'Нико'), P(44, 'Джон'),
];

export const MOMS = [
    P(21, 'Ханна'), P(22, 'Одри'), P(23, 'Жасмин'), P(24, 'Жизель'), P(25, 'Амелия'),
    P(26, 'Изабелла'), P(27, 'Зоуи'), P(28, 'Ава'), P(29, 'Камила'), P(30, 'Вайолет'),
    P(31, 'София'), P(32, 'Эвелин'), P(33, 'Николь'), P(34, 'Эшли'), P(35, 'Грейс'),
    P(36, 'Брианна'), P(37, 'Натали'), P(38, 'Оливия'), P(39, 'Элизабет'), P(40, 'Шарлотта'),
    P(41, 'Эмма'),
    P(45, 'Мисти'),
];

export const parentById = (id) => {
    const n = Number(id);
    return DADS.find((p) => p.id === n) || MOMS.find((p) => p.id === n) || null;
};
